import validate from '../../../services/reduxValidate.js'
import conf from '../../../conf.js'
import sharedConf from '../../../../shared/conf.js'

export default function (data) {
  const options = {
    main_universe: {
      presence: {
        message: 'Vous devez choisir un univers pour pouvoir vous inscrire'
      }
    },
    email: {
      email: {
        message: 'L\'adresse e-mail est invalide'
      },
      presence: true,
    },
    plain_password: {length: {minimum: 5}, presence: true},
    cgu_accepted: {
      presence: {
        message: 'Vous devez accepter les CGU pour pouvoir vous inscrire'
      },
      inclusion: {
        within: [true],
        message: 'Vous devez accepter les CGU pour pouvoir vous inscrire'
      }
    },
  }

  if (data.accountType === sharedConf.accountTypes.do) {
    const restrictedEmails = conf.restrictedEmails.join('|')
    options.email.format = {
      pattern: `^[a-z0-9\u007F-\uffff!#$%&'*+\\/=?^_\`{|}~-]+(?:\\.[a-z0-9\u007F-\uffff!#$%&'*+\\/=?^_\`{|}~-]+)*@(?:(?!${restrictedEmails})[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z]{2,}$`,
      message: 'Utilisez votre adresse professionelle.'
    }

    Object.assign(options, {
      tel: {
        presence: {allowEmpty: false},
        format: {
          pattern: /^\+?([0-9.\-\s]+)$/g,
          message: "Le numéro de téléphone est invalide (format souhaité : +33612345678)"
        }
      },
    })
  }

  return validate(data, options)
}
